import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Calendar({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'20px'} height={'22px'} viewBox={'0 0 20 22'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-2.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M5,5 C4.44771525,5 4,5.44771525 4,6 L4,20 C4,20.5522847 4.44771525,21 5,21 L19,21 C19.5522847,21 20,20.5522847 20,20 L20,6 C20,5.44771525 19.5522847,5 19,5 L5,5 Z M5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,20 C22,21.6568542 20.6568542,23 19,23 L5,23 C3.34314575,23 2,21.6568542 2,20 L2,6 C2,4.34314575 3.34314575,3 5,3 Z M15,2 C15,1.44771525 15.4477153,1 16,1 C16.5522847,1 17,1.44771525 17,2 L17,6 C17,6.55228475 16.5522847,7 16,7 C15.4477153,7 15,6.55228475 15,6 L15,2 Z M7,2 C7,1.44771525 7.44771525,1 8,1 C8.55228475,1 9,1.44771525 9,2 L9,6 C9,6.55228475 8.55228475,7 8,7 C7.44771525,7 7,6.55228475 7,6 L7,2 Z M3,11 C2.44771525,11 2,10.5522847 2,10 C2,9.44771525 2.44771525,9 3,9 L21,9 C21.5522847,9 22,9.44771525 22,10 C22,10.5522847 21.5522847,11 21,11 L3,11 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Calendar.propTypes = {
  className: PropTypes.string,
}
